import { api } from '@/api/core/api';

interface TriggerCp1IngestRequest {
  caseReferences: string[];
}

const triggerCp1IngestApi = api.injectEndpoints({
  endpoints: (builder) => ({
    triggerCp1Ingest: builder.mutation<void, TriggerCp1IngestRequest>({
      query: (body) => ({
        url: `cp1/trigger-ingest`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useTriggerCp1IngestMutation } = triggerCp1IngestApi;
